import {
  List,
  ListItemButton,
  Collapse,
  Typography,
  SxProps,
  Theme,
  useTheme,
} from "@mui/material";
import { ReactNode, useState } from "react";
import {
  ChevronSmallDownIcon,
  ChevronSmallUpIcon,
} from "@/components/common/icons";
import { WHITE } from "@/config/mui/colorPalette";

function ExpandableSection({
  title,
  children,
  unmount,
  expanded = false,
  onClick,
  sx,
}: {
  title: string;
  children: ReactNode;
  unmount?: boolean;
  expanded?: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}) {
  const [open, setOpen] = useState(expanded);
  const theme = useTheme();

  const handleListClick = () => {
    onClick && onClick();
    setOpen(!open);
  };

  return (
    <List
      disablePadding
      sx={{ width: "100%", bgcolor: WHITE, ...sx }}
      aria-label={title}
    >
      <ListItemButton onClick={handleListClick} sx={{ p: 0, m: 0 }}>
        <Typography
          variant="subtitleSmall"
          sx={{
            textAlign: "left",
            color: "text.secondary",
            flexGrow: 1,
          }}
        >
          {title}
        </Typography>
        {open ? (
          <ChevronSmallUpIcon color={theme.palette.primary.main} />
        ) : (
          <ChevronSmallDownIcon color={theme.palette.primary.main} />
        )}
      </ListItemButton>
      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit={unmount ?? true}
        aria-label={title}
      >
        {children}
      </Collapse>
    </List>
  );
}

export default ExpandableSection;
